"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
exports.default = {};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/async/internal/breakLoop.js
// module id = 154
// module chunks = 0